{
  "success": true,
  "errorMessage": "",
  "list": [
    {
      "srNo": 1,
      "firstName": "Name",
      "lastName": "Name",
      "dateOfBirth": "963873084",
      "relationCode": "01",
      "relationName": "Mother",
      "nationalityCode": "01",
      "nationalityName": "German",
      "passportNo": "23442",
      "winSports": 0
    },
    {
      "srNo": 2,
      "firstName": "Name-2",
      "lastName": "Name-2",
      "dateOfBirth": "963873084",
      "relationCode": "02",
      "relationName": "Brother",
      "nationalityCode": "01",
      "nationalityName": "German",
      "passportNo": "23442",
      "winSports": 1
    }
  ]
}
